// TSS vite/02 — centralized constants.

export const MAX_NAME_LEN = 255;
export const MAX_EMAIL_LEN = 255;
export const MAX_PHONE_LEN = 32;

export const MIN_PASSWORD_LEN = 8;

export const SEARCH_DEBOUNCE_MS = 300;
